import { IEBResourceManager } from "./resourceManager"
import { logwarn } from "./utils"

interface IEBProgressEvent {
  lengthComputable: boolean
  loaded: number
  total: number
}
const modName = "ebxhr"
class EBXMLHttpRequest implements XMLHttpRequest {

  public onabort: (this: XMLHttpRequest, ev: IEBProgressEvent) => any
  public onerror: (this: XMLHttpRequest, ev: IEBProgressEvent) => any
  public onload: (this: XMLHttpRequest, ev: IEBProgressEvent) => any
  public onloadend: (this: XMLHttpRequest, ev: any) => any
  public onloadstart: (this: XMLHttpRequest, ev: IEBProgressEvent) => any
  public onprogress: (this: XMLHttpRequest, ev: IEBProgressEvent) => any
  public ontimeout: (this: XMLHttpRequest, ev: IEBProgressEvent) => any

  public readyState: number = 0
  public response: any
  public responseText: string
  public responseType: XMLHttpRequestResponseType
  public responseURL: string
  public responseXML: Document
  public requestTime: number
  public responseTime: number
  public status: number
  public statusText: string
  public timeout: number = 10000
  public upload: XMLHttpRequestUpload
  public withCredentials: boolean = false// no credential for p2p requests

  public DONE: number = 4
  public HEADERS_RECEIVED: number = 2
  public LOADING: number = 3
  public OPENED: number = 1
  public UNSENT: number = 0

  private resourceManager: IEBResourceManager

  private timeoutBeforeSend: number = 50
  private timeoutID: any

  public onreadystatechange: (this: XMLHttpRequest, ev: any) => any = () => {}
  public abort(): void {
    clearTimeout(this.timeoutID)
  }
  public getAllResponseHeaders(): string {
    logwarn(modName, "getAllResponseHeaders method is not supported by current version")
    return ``
  }
  public getResponseHeader(name: string): string {
    return ""
  }
  public open(method: string, url: string, async?: any, username?: any, password?: any) {
    // check if it's get
    if (!this.resourceManager) {
      throw new Error("Resource Manager is not bound")
    }
    // TODO: if not, use the plain methods, maybe we can integrate resource manager
    if (method !== "GET") {
      throw new Error("Only GET is allowed")
    }
    if (!url) {
      throw new Error("Url should be set to send a request")
    }
    this.responseURL = url
    this.readyState = 1
    this.onreadystatechange({})
  }
  public overrideMimeType(mime: string): void {
    throw new Error("Method not implemented.")
  }
  public send(body?: string | Document | Blob | ArrayBufferView |
     ArrayBuffer | FormData | URLSearchParams | ReadableStream<Uint8Array>): void {
    this.requestTime = Date.now()
    if (this.responseType !== "arraybuffer") {
      throw new Error(`responseType ${this.responseType} unsupported`)
    }
    if (this.withCredentials) {
      throw new Error("WithCredential true is not supported")
    }
    if (!this.onload) {
      logwarn(modName, "Onload is not set, ignore the request")
      return
    }
    this.timeoutID = setTimeout(() => {
      clearTimeout(this.timeoutID)
      this.resourceManager.getResource(this.responseURL, this.timeout).
        then((array) => {
          const buffer: ArrayBuffer = array.buffer
          this.response = buffer
          this.readyState = 4
          this.status = 200
          this.statusText = "OK"
          this.responseTime = Date.now()
          this.onreadystatechange({})
          this.onload({
            lengthComputable: true,
            loaded: array.byteLength,
            total: array.byteLength,
          })
        }).catch((err) => {
          if (!this.onerror) {
            return
          }
          this.status = 409
          this.statusText = "OK"
          this.responseTime = Date.now()
          this.onreadystatechange({})
          this.onerror({
            lengthComputable: true,
            loaded: 0,
            total: 0,
          })
        }).finally(() => {
          if (this.onloadend) {
            this.onloadend({})
          }
        })
    }, this.timeoutBeforeSend)
  }
  public setRequestHeader(name: string, value: string): void {
    // TODO: implement the setRequestHeader
    logwarn(modName, "SetRequestHeader Method not implemented.")
  }

  public addEventListener(type: any, listener: any, options?: any) {
    // logwarn("listening to ", type)
    // throw new Error("Method not implemented.")
  }

  public removeEventListener(type: any, listener: any, options?: any) {
    throw new Error("Method not implemented.")
  }
  public dispatchEvent(event: Event): boolean {
    throw new Error("Method not implemented.")
  }

  public bindResourceManager(rm: IEBResourceManager): EBXMLHttpRequest {
    this.resourceManager = rm
    return this
  }

  public setTimeoutBeforeSend(to: number): EBXMLHttpRequest {
    this.timeoutBeforeSend = to
    return this
  }
}

export {
  EBXMLHttpRequest,
}
